import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // Phase U fix: for super-admin, auto-inject ?branch_id when an active branch is selected
  // in the sidebar, so list pages respect the dropdown. Only applies to GET on shared-resource
  // endpoints (products, parties, purchase-bills, purchase-returns). Skip if caller already set
  // branch_id explicitly. Cashier/Admin keep their server-side branch scoping (no need to inject).
  try {
    const role = localStorage.getItem("user_role");
    const activeBranch = localStorage.getItem("active_branch");
    if (
      role === "super_admin" &&
      activeBranch &&
      (config.method || "get").toLowerCase() === "get"
    ) {
      const url = config.url || "";
      const SHARED_LIST_PATHS = [
        "/products", "/parties", "/purchase-bills", "/purchase-returns",
        "/sales-bills", "/sales-returns", "/customers", "/expenses",
      ];
      const isSharedList = SHARED_LIST_PATHS.some((p) => {
        // Match path prefix but NOT a sub-resource like /products/:id (single-resource path)
        if (url === p) return true;
        if (url.startsWith(p + "?")) return true;
        return false;
      });
      if (isSharedList) {
        config.params = config.params || {};
        if (config.params.branch_id === undefined && !url.includes("branch_id=")) {
          config.params.branch_id = activeBranch;
        }
      }
    }
  } catch {}
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(Number(n) || 0);

export default api;
